import { render } from "./assenzaTreGiorni.vue?vue&type=template&id=7b90ed6b&ts=true"
import script from "./assenzaTreGiorni.vue?vue&type=script&lang=ts"
export * from "./assenzaTreGiorni.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__